import { Form, FormControlProps } from 'react-bootstrap';

import React from 'react';
import { useField } from 'formik';

interface TextInputProps extends FormControlProps {
    name: string;
    label?: string;
    placeholder?: string;
    style?: React.CSSProperties;
}

export const TextInput: React.FC<TextInputProps> = (props) => {
    const [field, meta] = useField({ name: props.name });
    const isDescription = props.label === 'Опис документу';

    // Auto-grow handler
    const handleInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        e.target.style.height = 'auto';
        e.target.style.height = e.target.scrollHeight + 'px';
    };

    return (
        <>
            <Form.Label>{props.label}</Form.Label>
            {isDescription ? (
                <Form.Control
                    as="textarea"
                    {...field}
                    {...props}
                    minRows={3}
                    style={{ minHeight: 80, resize: 'vertical', ...props.style }}
                    onInput={handleInput}
                />
            ) : (
                <Form.Control {...field} {...props} />
            )}
            {meta.touched && meta.error && <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>}
        </>
    );
};
